export const environment = {
  production: false,
  siteUrl: 'https://landing-dev.evrn.space',
  apiUrl: 'https://bff-dev.evrn.space',
  appUrl: 'https://app-dev.evrn.space',
};
